//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { showLoading, hideLoading } from '../../common/functions/loading';

export default {
  props: {
    menuList: {
      type: Array,
      default() {
        return [];
      },
    },
    abrir: false,
    logo: String,
  },
  data() {
    return {
      abrirMenu: false,
    };
  },
  watch: {
    abrir() {
      this.abrirMenu = !this.abrirMenu;
    },
  },
  methods: {
    lockBodyScroll() {
      document.body.style.overflowY = 'hidden';
    },
    onItemClicked(item) {
      if (!item.sub) {
        this.goToPage(item.route);
      }
    },
    getAbsolutePath() {
      return window.location.hash ? window.location.hash.replace('#/', '') : '';
    },
    shouldReloadRoute(route) {
      const { current } = this.$router.history;
      return current.matched.filter(m => m.name === route).length > 0;
    },
    goToPage(route) {
      this.abrirMenu = !this.abrirMenu;
      if (this.$route.name === route && this.$route.name !== 'importacoes') {
        return;
      }

      setTimeout(() => {
        if (!this.shouldReloadRoute(route)) {
          showLoading();
          this.$router
            .push({ name: route, params: { menu: true } }, null, () => hideLoading());
        } else {
          this.$router.go();
        }
      }, 500);
    },
    toggleLockBodyScroll() {
      document.body.style.overflowY = document.body.style.overflowY === 'hidden' ?
        'auto' :
        'hidden';
    },
    unlockBodyScroll() {
      document.body.style.overflowY = 'auto';
    },
    toggleExpand(...args) {
      $logger.log('Args', args);
    },
  },
  mounted() {
    $logger.log('Mounting', 'Sidebar');
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/sidebar/Sidebar.vue?vue&type=script&lang=js&